"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnpurchasedAvailableInstitutionalProducts = exports.useQuestionBankProducts = exports.useAvailableProductsByOrganization = exports.useAvailablePracticeExamAddons = exports.useAvailableInstitutionalProducts = void 0;
var _reactRedux = require("react-redux");
var _subscriptions = require("./subscriptions.js");
var _organizations = require("./organizations.js");
var useQuestionBankProducts = function useQuestionBankProducts() {
  var questionBank = (0, _subscriptions.useSelectedQuestionBankWithSubscriptions)();
  var products = (0, _reactRedux.useSelector)(function (state) {
    return state.products;
  });
  return products.toList().filter(function (product) {
    return !product.get('student_purchase_option') && product.get('question_bank_ids').includes(questionBank.get('id'));
  });
};
exports.useQuestionBankProducts = useQuestionBankProducts;
var useAvailableInstitutionalProducts = function useAvailableInstitutionalProducts() {
  var products = (0, _reactRedux.useSelector)(function (state) {
    return state.products;
  });
  return products.toList().filter(function (product) {
    return product.get('student_purchase_option');
  });
};
exports.useAvailableInstitutionalProducts = useAvailableInstitutionalProducts;
var useUnpurchasedAvailableInstitutionalProducts = function useUnpurchasedAvailableInstitutionalProducts() {
  var availableProducts = useAvailableInstitutionalProducts();
  var purchasedIds = (0, _subscriptions.useProductIdsForUserSubscriptions)();
  // already getting the data as toList
  return availableProducts.filter(function (product) {
    return !purchasedIds.includes(product.get('id'));
  });
};
exports.useUnpurchasedAvailableInstitutionalProducts = useUnpurchasedAvailableInstitutionalProducts;
var useAvailableProductsByOrganization = function useAvailableProductsByOrganization() {
  var userOrgs = (0, _organizations.useVerifiedOrganizationsForCurrentUser)();
  var products = useUnpurchasedAvailableInstitutionalProducts();
  // already getting the data as toList
  return userOrgs.map(function (org) {
    var studentProducts = products.filter(function (product) {
      return org.get('student_purchase_option_ids').includes(product.get('id'));
    });
    return org.set('products', studentProducts);
  });
};
exports.useAvailableProductsByOrganization = useAvailableProductsByOrganization;
var useAvailablePracticeExamAddons = function useAvailablePracticeExamAddons() {
  // already getting the data as toList
  var products = useQuestionBankProducts();
  return products.filter(function (product) {
    return product.get('category') === 'practice_exam';
  });
};
exports.useAvailablePracticeExamAddons = useAvailablePracticeExamAddons;